import { render, staticRenderFns } from "./ProductCompareButton.vue?vue&type=template&id=386bca72&"
import script from "./ProductCompareButton.vue?vue&type=script&lang=js&"
export * from "./ProductCompareButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports